import { Alert, Button, Chip, Stack, Typography } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Avatar from "@poseidon/ui/components/Avatar";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { capitalizeFirstLetter } from "@poseidon/utils/string";
import { niceDate } from "@poseidon/utils/date";
import { useState } from "react";

const UserAvatar = ({ user, userType }) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Avatar
        firstName={user?.firstName}
        lastName={user?.lastName}
        size="small"
      />
      <Typography>{`${user?.firstName} ${user?.lastName}`}</Typography>
      <Chip size="small" label={userType} />
    </Stack>
  );
};
const getUpdateText = (update) => {
  if (update.state === "complete") {
    return "Marked as complete";
  }
  if (update.state === "pendingApproval") {
    return "Marked as pending approval";
  }
  if (update.state === "processing") {
    return "Marked as processing";
  }
  if (update.state === "actionRequired") {
    const actionFor =
      typeof update.actionFor === "string"
        ? update.actionFor
        : update.actionFor?.parent?.id?.replace(/s$/, "") ?? "unknown";

    return `Marked as action required for ${actionFor}${
      update.note ? `, with note "${update.note}"` : ""
    }`;
  }
  return `Unrecognised state "${update.state}"`;
};
export const ActionChangeLogTable = ({ log, loading, error }) => {
  const [showAll, setShowAll] = useState(false);
  return (
    <Stack mt={2}>
      {loading && <LinearProgress />}
      {error && "Error!"}
      {!loading && !error && log && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell component="th">Timestamp</TableCell>
              <TableCell component="th">User</TableCell>
              <TableCell component="th">Update</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {log
              .sort((a, b) => b.createdAt - a.createdAt)
              .slice(0, showAll ? log.length : 5)
              .map(({ id, updatedBy, createdAt, update }) => (
                <TableRow key={id}>
                  <TableCell title={createdAt.toLocaleString("en-GB")}>
                    {capitalizeFirstLetter(niceDate(createdAt))}
                  </TableCell>
                  <TableCell>
                    {updatedBy && (
                      <WithDoc
                        docRef={`${updatedBy.userType}s/${updatedBy.user.id}`}
                        Component={({ data: user }) => (
                          <UserAvatar
                            user={user}
                            userType={updatedBy.userType}
                          />
                        )}
                      />
                    )}
                  </TableCell>
                  <TableCell>{getUpdateText(update)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      )}
      {log.length > 5 && (
        <Button variant="text" onClick={() => setShowAll((v) => !v)}>
          Show {showAll ? "Less" : "More"}
        </Button>
      )}
      {!loading && !error && (!log || log.length < 1) && (
        <Alert sx={{ borderRadius: 0 }} severity="info">
          No changes recorded for Action yet
        </Alert>
      )}
    </Stack>
  );
};
